var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h3", { staticClass: "text-center mb-6" }, [
      _vm._v(_vm._s(_vm.$t("roomWizard.checkUpdates")))
    ]),
    _vm.updates
      ? _c(
          "div",
          { staticClass: "text-center" },
          [
            _c("h4", { staticClass: "mb-6" }, [
              _vm._v(_vm._s(_vm.$t("roomWizard.updateNeeded")))
            ]),
            _c("va-button", {
              attrs: {
                disabled: _vm.updating,
                loading: _vm.loading,
                cta: _vm.$t("roomWizard.restart")
              },
              on: { click: _vm.updateDevice }
            }),
            _vm.updating
              ? _c("div", { staticClass: "text-center my-6" }, [
                  _vm._v(" " + _vm._s(_vm.$t("roomWizard.updating"))),
                  _c("br"),
                  _vm._v(" " + _vm._s(_vm.$t("roomWizard.safeToClose")) + " ")
                ])
              : _vm._e()
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "text-center" },
          [
            _c("h4", { staticClass: "mb-6" }, [
              _vm._v(_vm._s(_vm.$t("roomWizard.upToDate")))
            ]),
            _c("va-icon", {
              attrs: { icon: "vi vi-c-check", color: "success", size: "l" }
            })
          ],
          1
        ),
    _c(
      "div",
      { staticClass: "d-flex justify-space-between my-8" },
      [
        !_vm.first
          ? _c("va-button", {
              staticClass: "mr-4",
              attrs: {
                disabled:
                  !!_vm.loading ||
                  (!!_vm.updates &&
                    _vm.deviceConfiguration.installedProduct !== "enterprise"),
                color: "secondary",
                type: "outline",
                cta: _vm.$t("roomWizard.prev")
              },
              on: { click: _vm.onBack }
            })
          : _c("v-spacer"),
        _c("va-button", {
          attrs: {
            disabled: !!_vm.loading || !!_vm.updates,
            loading: _vm.loading,
            cta: _vm.$t("roomWizard.next")
          },
          on: { click: _vm.onNext }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }